import { Base } from '../base-component';

import './call-me-back.component.scss';

import * as $ from 'jquery';

export class CallMeBack extends Base {

	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;
	openButton: Element;
	buttonContainer: Element;

	toggleTabsButtons: Element[];
	tabs: Element[];

	callMeBackForm: HTMLFormElement;
	formSubmitButton: Element;
	formRadioButtons: Element[];

	formSuccessMessage: Element;
	formErrorMessage: Element;

	private static instance: CallMeBack;

	constructor(element: Element) {
		super(element);
		this.event.register('openCallMeBackModal', this, this.openCallMeBackModal.bind(this));
	}

	init() {

		this.modals = Array.from(this.element.querySelectorAll('.js-call-me-back-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-call-me-back-modal-open'));
		this.closeButton = this.element.querySelector('.js-call-me-back-modal-close');
		this.openButton = this.element.querySelector('.js-call-me-back-modal-open');
		this.buttonContainer = this.element.querySelector('.call-me-back-toggle');

		this.toggleTabsButtons = Array.from(this.element.querySelectorAll('.js-toggle-tab'));
		this.tabs = Array.from(this.element.querySelectorAll('.call-me-back__tab-content'));

		this.callMeBackForm = this.element.querySelector('form') as HTMLFormElement;
		this.formSubmitButton = this.element.querySelector('.js-call-me-back-submit');
		this.formRadioButtons = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));

		this.formSuccessMessage = this.element.querySelector('.js-call-me-back-success-message');
		this.formErrorMessage = this.element.querySelector('.js-call-me-back-error-message');

	}

	bindEvents() {

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideCallMeBackModal(event);
		}));

		window.addEventListener('scroll', (event) => this.onScroll(event));

		this.closeButton.addEventListener('click', (event) => this.closeCallMeBackModal());

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openCallMeBackModals(event);
		}));

		this.toggleTabsButtons.map((item) => item.addEventListener('click', (event) => {
			this.toggleTabs(event);
		}));


		this.formRadioButtons.map((item) => item.addEventListener('click', (event) => {
			const evt: any = event.target;
			const identificationField: any = this.callMeBackForm.querySelector('input[name=identification]');
			const identificationType: any = evt.value;

			if(identificationType === 'said'){

				identificationField.classList.remove('form__input--identification--passport');
				identificationField.classList.add('form__input--identification');
				identificationField.placeholder = 'Enter you South Africa ID number';
				identificationField.type = 'number';

			}else{

				identificationField.classList.remove('form__input--identification');
				identificationField.classList.add('form__input--identification--passport');
				identificationField.placeholder = 'Enter you Passport number';
				identificationField.type = 'text';

			}

		}));

		if(this.formSubmitButton) {

			this.formSubmitButton.addEventListener('click', () => {
				const formFields: any = this.callMeBackForm.querySelectorAll('input, select');
				const validation = this.validationService.validate(formFields);
				if(validation.valid) {
					this.formsService.detect(this.callMeBackForm, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
				}else{
					this.showErrorPopup();
				}
			});
			
		}

		this.formErrorMessage.addEventListener('click', () => this.hideErrorPopup());

		let inputFields = this.element.querySelectorAll('input');
		for (let i = 0; i < inputFields.length; i++) {
			inputFields[i].addEventListener('input', () => this.hideErrorsOnFields());
		}

	}

	onScroll(event) {

		setTimeout(() => {

			let footerHeight = document.querySelector('footer').offsetHeight;

			if ((window.innerHeight + document.documentElement.scrollTop) >= (document.body.offsetHeight - footerHeight)) {
			    this.hideComponent();
			} else {
				this.showComponent();
			}

		}, 200);

	}

	showComponent() {
		this.element.classList.remove('call-me-back--hidden');
	}

	hideComponent() {
		this.element.classList.add('call-me-back--hidden');
	}

	isClickOutsideCallMeBackModal(event) {

		if (event.target === this.activeModal) {
			this.closeCallMeBackModal();
		}

	}

	openCallMeBackModals(event) {

		let element: any = event.target;
		let modalId: any = element.getAttribute('data-modal');
		if(!modalId){
			let parentElement: any = $(element).closest('.js-call-me-back-modal-open');
			modalId = parentElement.attr('data-modal');
		}
		this.activeModal = this.getCallMeBackModalById(modalId);
		this.openCallMeBackModal();

	}

	closeCallMeBackModal() {

		this.analyticsService.dtmFormAbandon();
		this.activeModal.classList.add('modal--close');
		this.activeModal.querySelector('.call-me-back__modal-dialog').classList.remove('call-me-back__modal-dialog--open');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

		this.showOpenButton();

		setTimeout(() => {
			this.hideSuccessMessage();
		}, 500);

	}

	openCallMeBackModal() {

		this.resetForm();
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
		this.activeModal.querySelector('.call-me-back__modal-dialog').classList.add('call-me-back__modal-dialog--open');
		this.showCloseButton();

	}

	getCallMeBackModalById(id) {
		return document.querySelector(`#${id}`);
	}

	showOpenButton() {

		this.closeButton.classList.remove('call-me-back-toggle__toggle-icon--visible');

		setTimeout(() => {
			this.buttonContainer.classList.add('call-me-back-toggle--closed');
		}, 150);

		setTimeout(() => {
        	this.openButton.classList.add('call-me-back-toggle__toggle-text--visible');
		}, 300);

	}

	showCloseButton() {

		this.openButton.classList.remove('call-me-back-toggle__toggle-text--visible');

		setTimeout(() => {
			this.buttonContainer.classList.remove('call-me-back-toggle--closed');
		}, 150);

		setTimeout(() => {
        	this.closeButton.classList.add('call-me-back-toggle__toggle-icon--visible');
		}, 300);

	}

	toggleTabs(event) {

		this.hideTabs();

		event.currentTarget.classList.add('call-me-back__tab--active');

		let goToTab = event.currentTarget.getAttribute('data-tab');
		this.element.querySelector(`#${goToTab}`).classList.add('call-me-back__tab-content--active');
	}

	hideTabs() {

		for (let i = 0; i < this.toggleTabsButtons.length; i++) {
			this.toggleTabsButtons[i].classList.remove('call-me-back__tab--active');
		}

		for (let i = 0; i < this.tabs.length; i++) {
			this.tabs[i].classList.remove('call-me-back__tab-content--active');
		}

	}

	submitForm(event) {

		event.preventDefault();

		let validated = this.validateInput();

		if (validated) {

			let form = document.querySelector('form');
			let data = new FormData(form);

			console.log(data);

			this.showSuccessMessage();

		} else {

			this.showErrors();

			setTimeout(() => {
				this.hideErrorPopup();
			}, 5000);

		}

	}

	validateInput() {

		let inputs = document.querySelector('form').getElementsByTagName('input');

		for (let i = 0; i < inputs.length; i++) {

			if (!inputs[i].value) {
				return false;
			}

		}

		return true;

	}

	showErrors() {

		let formGroups = document.getElementsByClassName('form__group');

		for (let i = 0; i < formGroups.length; i++) {

			var input = formGroups[i].querySelector('input');

			if (input.value === '') {
				formGroups[i].classList.add('form__group--error');
			}

		}

		this.showErrorPopup();

	}

	showErrorPopup() {

		this.formErrorMessage.classList.add('call-me-back__error-message--visible');

		setTimeout(() => {
			this.formErrorMessage.classList.remove('call-me-back__error-message--hidden');
		}, 250);

	}

	hideErrorPopup() {

		this.formErrorMessage.classList.add('call-me-back__error-message--hidden');

		setTimeout(() => {
			this.formErrorMessage.classList.remove('call-me-back__error-message--visible');
		}, 250);

	}

	hideErrorsOnFields() {

		let formGroupsWithErrors = document.getElementsByClassName('form__group--error');

		for (let i = 0; i < formGroupsWithErrors.length; i++) {
			formGroupsWithErrors[i].classList.remove('form__group--error');
		}

		this.hideErrorPopup();

	}

	showSuccessMessage() {

		this.hideErrorsOnFields();

		this.callMeBackForm.classList.remove('call-me-back__form--visible');
		this.formSuccessMessage.classList.add('call-me-back__message--visible');

	}

	hideSuccessMessage() {
		this.formSuccessMessage.classList.remove('call-me-back__message--visible');
		this.callMeBackForm.classList.add('call-me-back__form--visible');
	}

	resetForm() {

		if(this.callMeBackForm){
			this.callMeBackForm.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');

			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}

	}

}



// WEBPACK FOOTER //
// ./components/call-me-back/call-me-back.component.ts